// Removes non-ASCII characters from a string

export default function removeNonAsciiChars(str) {
  if (!str || str === true) return str
  return str.replace(/[^\x20-\x7E]/g, '')
}
